export default "__VITE_ASSET__CkJTJ8oW__"